import { ArrowRight, PackageCheck } from "lucide-react";
import { BUNDLES } from "@/data/bundles";
import { FadeIn } from "@/components/Reveal";

export const Bundles = () => (
  <section id="bundles" className="bg-white py-24 lg:py-32" data-testid="bundles-section">
    <div className="container-tsm">
      <FadeIn className="max-w-2xl">
        <p className="eyebrow">Service Bundles</p>
        <h2
          className="mt-6 font-serif text-4xl font-semibold leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl"
          data-testid="bundles-headline"
        >
          Tiered Support for Every Stage of Business
        </h2>
        <p className="mt-7 leading-relaxed text-ink/70" data-testid="bundles-intro">
          Combine compliance support and operational services into a package that fits how your business runs.
          Bundle details and pricing are confirmed directly with you for each engagement.
        </p>
      </FadeIn>

      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {BUNDLES.map((bundle, i) => (
          <FadeIn key={bundle.name + i} delay={i * 0.1}>
            <div
              className={`flex h-full flex-col rounded-lg border bg-paper p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] ${
                i === 1 ? "border-gold" : "border-navy/10"
              }`}
              data-testid={`bundle-card-${i + 1}`}
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-sm ${
                  i === 1 ? "bg-gold text-navy" : "bg-navy text-gold"
                }`}
              >
                <PackageCheck className="h-5 w-5" />
              </span>
              <h3 className="mt-6 font-serif text-3xl font-semibold text-navy">{bundle.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink/60">{bundle.description}</p>
              <ul className="mt-6 flex-1 space-y-2.5 border-t border-navy/10 pt-6">
                {bundle.items.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm text-ink/75">
                    <ArrowRight className="mt-0.5 h-3.5 w-3.5 shrink-0 text-golddark" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-6 font-mono text-[11px] font-semibold uppercase tracking-[0.18em] text-navy/50">
                {bundle.price || "Contact us for pricing"}
              </p>
              <a href="#request" data-testid={`bundle-cta-${i + 1}`} className="btn-outline mt-5 w-full">
                Ask About a Bundle
                <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          </FadeIn>
        ))}
      </div>

      <FadeIn delay={0.2}>
        <p className="mt-10 text-center text-sm italic text-ink/50" data-testid="bundles-note">
          Bundles can be tailored to your organization — contact TSM Group CLE to combine services for your team.
        </p>
      </FadeIn>
    </div>
  </section>
);
